import { createStore } from 'owa-satcheljs';
import type { owaMonarchReferralCampaignState } from './schema/owaMonarchReferralCampaignState';

export const getOwaMonarchReferralCampaignStore: () => owaMonarchReferralCampaignState =
    createStore<owaMonarchReferralCampaignState>('owaMonarchReferralCampaignState', {
        viewState: 'idle',
        title: '',
        body: '',
        primaryCta: '',
        secondaryCta: '',
        image: '',
        campaignId: '',
        trackingBaseUri: '',
        impressionBaseUri: '',
    });
